import type { ReactNode } from "react";
import { useIsClient } from "@/hooks/useIsClient";

/**
 * Renders children only on the client (after hydration).
 * Uses useSyncExternalStore to safely defer to client rendering,
 * preventing SSR from attempting to render browser-only components.
 */
export function ClientOnly({ children, fallback }: { children: ReactNode; fallback?: ReactNode }) {
  const isClient = useIsClient();
  return isClient ? <>{children}</> : <>{fallback ?? null}</>;
}
